import { Badge } from '../ui/badge';

const MAP = {
  PRESENT:    { label: 'Present',    variant: 'green'  },
  ABSENT:     { label: 'Absent',     variant: 'red'    },
  LATE:       { label: 'Late',       variant: 'yellow' },
  LEAVE:      { label: 'On Leave',   variant: 'blue'   },
  HALF_DAY:   { label: 'Half Day',   variant: 'purple' },
  HOLIDAY:    { label: 'Holiday',    variant: 'default'},
  WEEKEND:    { label: 'Weekend',    variant: 'default'},
  ACTIVE:     { label: 'Active',     variant: 'green'  },
  INACTIVE:   { label: 'Inactive',   variant: 'default'},
  PENDING:    { label: 'Pending',    variant: 'yellow' },
  APPROVED:   { label: 'Approved',   variant: 'green'  },
  REJECTED:   { label: 'Rejected',   variant: 'red'    },
  CANCELLED:  { label: 'Cancelled',  variant: 'default'},
  REIMBURSED: { label: 'Reimbursed', variant: 'green'  },
  DRAFT:      { label: 'Draft',      variant: 'default'},
  PROCESSING: { label: 'Processing', variant: 'blue'   },
  PAID:       { label: 'Paid',       variant: 'green'  },
  FAILED:     { label: 'Failed',     variant: 'red'    },
  FULL_TIME:  { label: 'Full Time',  variant: 'blue'   },
  PART_TIME:  { label: 'Part Time',  variant: 'purple' },
  CONTRACT:   { label: 'Contract',   variant: 'yellow' },
  DAILY_WAGE: { label: 'Daily Wage', variant: 'default'},
  ACTIVE_JOB: { label: 'Active',     variant: 'green'  },
  CLOSED:     { label: 'Closed',     variant: 'default'},
};

export function StatusBadge({ status, className }) {
  const cfg = MAP[status] || { label: status, variant: 'default' };
  return <Badge variant={cfg.variant} dot className={className}>{cfg.label}</Badge>;
}
export default StatusBadge;
